import React from 'react';
import { t } from 'i18next';

export function AddButtons(handlePublish, isLoading, handlePreview) {
    return <div className="bg-[var(--background-white-color)] rounded-[10px] p-5 mt-2.5 mobile_show flex flex-col gap-2.5 md:hidden">
        <button
            className="py-2.5 px-4 rounded-[10px] border-none cursor-pointer text-base bg-[var(--primary-color)] text-white w-full h-[40px] flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed mb-2.5"
            onClick={handlePublish}
            disabled={isLoading}
        >
            {isLoading ? <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : t('publish')}
        </button>
        <button
            className="py-2.5 px-4 rounded-[10px] border border-[var(--primary-color)] bg-transparent text-[var(--text-color)] cursor-pointer text-base w-full h-[40px] flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={isLoading}
            onClick={handlePreview}
        >
            {t('preview')}
        </button>
    </div>;
}